import { Modal } from "react-bootstrap";

const DatabaseModal = ({ isOpen, onClose, data }) => {
  if (!isOpen || !data) return null;
  console.log(data.dataBases, "databaseData");

  // Helper function to return badge class
  const getStatusClass = (status) => {
    switch (status) {
      case "Available":
        return "pill bgsuccess";
      case "Creating":
        return "pill bgsuccess";
      case "Created":
        return "pill bgsuccess";  
      case "-":
        return "pill badge bgsecondary";
      default:
        return "pill badge text-bg-dark";
    }
  };

  return (
    <Modal show={isOpen} onHide={onClose} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title className="fs-5">Database Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="table-responsive">
          <table className="table table-striped table-bordered align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(data?.dataBases) &&
                data.dataBases.map((db, index) => (
                  <tr key={index}>
                    <td>{db.name}</td>
                    <td>
                      {db.status === "not yet created" ? (
                        <div className="d-flex align-items-center gap-2">
                          <div
                            className="spinner-border spinner-border-sm text-secondary"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      ) : (
                        <span className={getStatusClass(db.status)}>
                          {db?.status.toLowerCase() === "creating" ? "Creating..." : db?.status}
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DatabaseModal;
